export const maxPrice = 500000000
export const maxArea = 135000
export const maxRooms = 500
export const maxYield = 30
export const defaultLimit = 100
export const defaultPriceStep = 1000000
export const defaultAreaStep = 1000
export const defaultRoomsStep = 5
export const defaultYieldStep = 1



// WEBPACK FOOTER //
// ./src/Utils/Constants.js